/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '@components/common/primitives';

export const ErrorContainer = styled(Box)`
  background: ${themeGet('colors.error')};
  border: 1px solid ${themeGet('colors.blackout')};
  color: ${themeGet('colors.body')};
  text-align: center;
  padding: 1rem;
`;

export const WarningContainer = styled(ErrorContainer)`
  background: #ffa105;
  color: #071820;
`;
